import React from "react";

const YesOrNo = ({
  title,
  name,
  acceptTitle = "Yes",
  rejectTitle = "No",
  value,
  onChange = () => {},
  disabled = false,
}) => (
  <div className="d-flex">
    <div className="mr-3">{title}</div>
    <div className="d-flex justify-content-start">
      <div className="pr-4">
        <label className="radio radio-primary form-check-inline mb-0">
          <input
            type="radio"
            name={name}
            value="Yes"
            checked={value === true}
            onChange={({ target: { name } }) =>
              onChange({ target: { name, type: "checkbox", checked: true } })
            }
            disabled={disabled}
          />
          <span>{acceptTitle}</span>
          <span className="checkmark"></span>
        </label>
      </div>
      <div className="pr-2">
        <label className="radio radio-primary form-check-inline mb-0">
          <input
            type="radio"
            name={name}
            value="No"
            checked={value === false}
            onChange={({ target: { name } }) =>
              onChange({ target: { name, type: "checkbox", checked: false } })
            }
            disabled={disabled}
          />
          <span>{rejectTitle}</span>
          <span className="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
);

export default YesOrNo;
